"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVerificationURL = void 0;
const createVerificationURL = (baseUrl, redirect) => {
    let result = baseUrl;
    const tokenAssignation = 'workEmailVerifyToken=';
    if (redirect) {
        result += '?redirect=' + redirect + '&' + tokenAssignation;
    }
    else {
        result += '?' + tokenAssignation;
    }
    return result;
};
exports.createVerificationURL = createVerificationURL;
//# sourceMappingURL=verificationUrl.js.map